import { IoMdFlash as FlashIcon } from "react-icons/io";
import styles from "./InstantBooking.module.css";

export default function InstantBooking() {
  return (
    <div className={styles.InstantBooking}>
      <span className={styles.InstantBookingIcon}>
        <FlashIcon size={18} color={"#ec881e"} />
      </span>
      Instant Booking
    </div>
  );
}
